import z from 'zod';

export enum QuizSessionFeedback {
  GOOD = 'good',
  BAD = 'bad',
  AVERAGE = 'average',
}

export const quizSessionFeedbackSchema = z.enum(QuizSessionFeedback);
